// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Anchor, Container } from './styles';

// helpers
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';

// constants
const label = 'Offer';

interface Props {
  discount: {
    action_url?: string;
    text: string;
  };
}

function Discount({ discount }: Props) {
  const sanitizedDiscountText = sanitizeHTML(discount.text);

  if (isEmpty(discount.action_url)) {
    return <Container className="bannerText" dangerouslySetInnerHTML={{ __html: sanitizedDiscountText }} />;
  }

  return (
    <Anchor
      as="a"
      href={discount.action_url}
      aria-label={label}
      dangerouslySetInnerHTML={{ __html: sanitizedDiscountText }}
      className="bannerText"
    />
  );
}

export default memo(Discount);
